<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        <div class="flex w-full flex-col gap-2">
            @if (dropZone) {
                <kendo-uploaddropzone zoneId="external-drop-zone">
                    <kendo-fileselect-messages [externalDropFilesHere]="'Drag and drop files here' | translate" />
                </kendo-uploaddropzone>
            }
            <kendo-fileselect
                class="w-full rounded-sm"
                zoneId="external-drop-zone"
                [ngClass]="generateInputStyle()"
                [id]="id"
                [title]="title | translate"
                [restrictions]="restrictions"
                [showFileList]="showFileList"
                [multiple]="isMultiple"
                [disabled]="isDisabled"
                [required]="isRequired"
                [(ngModel)]="value"
                (select)="onFileSelected($event)"
                (focusin)="onFocusIn()"
                (focusout)="onFocusOut()">
                <kendo-fileselect-messages
                    [select]="isMultiple ? ('Select files...' | translate) : ('Select file...' | translate)"
                    [dropFilesHere]="'Drop files here' | translate" />
            </kendo-fileselect>
        </div>
    } @else {
        <div class="w-full truncate pt-1.5 pb-1">
            <span kendoTooltip [title]="value()">
                {{ value() }}
            </span>
        </div>
    }
</app-input-label>
